import { Card } from '@/components';
import YieldBearingAssetsList, {
  InformationAmount,
} from '@/components/organisms/YieldBearingAssetsList/YieldBearingAssetsList';
import APP_CONFIG from '@/config/app';
import { FC } from 'react';
const TrendingYieldBearingAssetsCardBody: FC = (): JSX.Element => {
  return (
    <Card.Body>
      <YieldBearingAssetsList
        filters={{
          limit:
            APP_CONFIG.TRENDING_YIELD_BEARING_ASSETS_CARD.NO_OF_ASSETS_TO_SHOW,
          tickers: APP_CONFIG.TRENDING_YIELD_BEARING_ASSETS_CARD.ASSETS,
        }}
        amountOfInformationToShow={InformationAmount.LEAST_INFORMATION}
      />
    </Card.Body>
  );
};
export default TrendingYieldBearingAssetsCardBody;
